import { useEffect, useRef, useState } from 'react';
import { fetchUserEvents } from '../../api/events';
import { UnpopulatedEvent } from '../../utils/types';

export const useNextEvents = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [userEvents, setUserEvents] = useState<UnpopulatedEvent[] | null>(
        null
    );
    const [error, setError] = useState(null);
    const [takeEvents, setTakeEvents] = useState(30);

    const initialized = useRef(false);

    async function fetchEvents() {
        setIsLoading(true);
        try {
            const data = await fetchUserEvents();
            setUserEvents(data);
        } catch (error: any) {
            console.warn(error);
            setError(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        async function fetchData() {
            try {
                fetchEvents();
            } catch (error: any) {
                console.warn(error);
                setError(error);
            }
        }

        if (!initialized.current) {
            initialized.current = true;
            fetchData();
        }
    }, [initialized]);

    // const showLoadMoreFeedsButton = useMemo(
    //     () => feeds?.length === takeFeeds,
    //     [feeds, takeFeeds]
    // );

    // const onShowMoreFeedsClick = async () => {
    //     const newTake = takeFeeds + 30;
    //     setTakeFeeds(newTake);
    //     fetchFeeds(newTake);
    // };

    return {
        // onShowMoreFeedsClick,
        // showLoadMoreFeedsButton,
        isLoading,
        userEvents,
        error,
    };
};
